import { importClass } from "../../utilities/dynamicImportsUtility";

export default class CouponWidgetSlim extends HTMLElement {
  public constructor() {
    super();
  }

  public connectedCallback() {
    console.debug("Coupon Widget Slim registered");
    if (document.readyState === "loading") {
      window.addEventListener("DOMContentLoaded", () => this.initialize());
    } else {
      this.initialize();
    }
  }

  private async initialize() {
    importClass(
      () =>
        import(
          /* webpackChunkName: "couponWidgetSlimController" */ "./couponWidgetSlimController"
        ),
      true,
      new Array<HTMLElement>(this)
    );
  }
}

customElements.define("coupon-widget-slim", CouponWidgetSlim);
